import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeShareable = makeShareable;
exports.makeShareableCloneOnUIRecursive = void 0;
exports.makeShareableCloneRecursive = makeShareableCloneRecursive;
exports.registerShareableMapping = registerShareableMapping;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _PlatformChecker = require("./PlatformChecker");
var _errors = require("./errors");
var _jsVersion = require("./platform-specific/jsVersion");
var USE_STUB_IMPLEMENTATION = (0, _PlatformChecker.shouldBeUseWeb)();
var _shareableCache = new WeakMap();
var _shareableFlag = Symbol("shareable flag");
var MAGIC_KEY = "REANIMATED_MAGIC_KEY";
var _worklet_6457566696199_init_data = {
    code: "function isHostObject(value){const{MAGIC_KEY}=this.__closure;return MAGIC_KEY in value;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts",
    sourceMap: '{"version":3,"names":["isHostObject","value","MAGIC_KEY","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts"],"mappings":"AA0BA,SAAAA,YAASA,CAAaC,KAAA,CAA0B,OAAAC,SAAA,OAAAC,SAAA,CAM9C,MAAO,CAAAD,SAAS,GAAI,CAAAD,KAAK,CAC3B"}',
    version: "3.5.4"
};
var isHostObject = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var isHostObject = function isHostObject(value) {
        return MAGIC_KEY in value;
    };
    isHostObject.__closure = {
        MAGIC_KEY: MAGIC_KEY
    };
    isHostObject.__initData = _worklet_6457566696199_init_data;
    isHostObject.__workletHash = 6457566696199;
    isHostObject.__stackDetails = _e;
    return isHostObject;
}();
function registerShareableMapping(shareable, shareableRef) {
    if (USE_STUB_IMPLEMENTATION) {
        return;
    }
    _shareableCache.set(shareable, shareableRef || _shareableFlag);
}
function isPlainJSObject(object) {
    return Object.getPrototypeOf(object) === Object.prototype;
}
var _worklet_5686620446469_init_data = {
    code: "function anonymous(){return new Proxy({},{get:function(_,prop){if(prop==='_isReanimatedSharedValue'){return false;}throw new Error(\"[Reanimated] Trying to access property `\"+String(prop)+\"` of an object which cannot be sent to the UI runtime.\");},set:function(){throw new Error('[Reanimated] Trying to write to an object which cannot be sent to the UI runtime.');}});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts",
    sourceMap: '{"version":3,"names":["anonymous","Proxy","get","_","prop","Error","String","set"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts"],"mappings":"AAyDU,SAAAA,SAAMA,CAAA,EAEZ,MAAO,IAAI,CAAAC,KAAK,CACd,CAAC,CAAC,CACF,CACEC,GAAG,CAAE,QAAAA,CAACC,CAAM,CAAEC,IAAqB,CAAK,CACtC,GAAIA,IAAI,GAAK,0BAA0B,CAAE,CAQvC,MAAO,MAAK,CACd,CACA,KAAM,IAAI,CAAAC,KAAK,4CAC+BC,MAAM,CAChDF,IACF,CAAE,yDACJ,CAAC,CACH,CAAC,CACDG,GAAG,CAAE,QAAAA,CAAA,CAAM,CACT,KAAM,IAAI,CAAAF,KAAK,CACb,mFACF,CAAC,CACH,CACF,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var INACCESSIBLE_OBJECT = {
    __init: function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous() {
            return new Proxy({}, {
                get: function get(_, prop) {
                    if (prop === "_isReanimatedSharedValue") {
                        return false;
                    }
                    throw new Error("[Reanimated] Trying to access property `".concat(String(prop), "` of an object which cannot be sent to the UI runtime."));
                },
                set: function set() {
                    throw new Error("[Reanimated] Trying to write to an object which cannot be sent to the UI runtime.");
                }
            });
        };
        anonymous.__closure = {};
        anonymous.__initData = _worklet_5686620446469_init_data;
        anonymous.__workletHash = 5686620446469;
        anonymous.__stackDetails = _e;
        return anonymous;
    }()
};
var DETECT_CYCLIC_OBJECT_DEPTH_THRESHOLD = 30;
var processedObjectAtThresholdDepth;
var _worklet_17031627990684_init_data = {
    code: "function anonymous(){const{pattern,flags}=this.__closure;return new RegExp(pattern,flags);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts",
    sourceMap: '{"version":3,"names":["anonymous","pattern","flags","__closure","RegExp"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts"],"mappings":"AAmMkB,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,KAAA,OAAAC,SAAA,CAEZ,MAAO,IAAI,CAAAC,MAAM,CAACH,OAAO,CAAEC,KAAK,CAAC,CACnC"}',
    version: "3.5.4"
};
function makeShareableCloneRecursive(value) {
    var shouldPersistRemote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (USE_STUB_IMPLEMENTATION) {
        return value;
    }
    if (depth >= DETECT_CYCLIC_OBJECT_DEPTH_THRESHOLD) {
        if (depth === DETECT_CYCLIC_OBJECT_DEPTH_THRESHOLD) {
            processedObjectAtThresholdDepth = value;
        } else if (value === processedObjectAtThresholdDepth) {
            throw new Error("[Reanimated] Trying to convert a cyclic object to a shareable. This is not supported.");
        }
    } else {
        processedObjectAtThresholdDepth = undefined;
    }
    var type = typeof value === "undefined" ? "undefined" : _type_of(value);
    var isTypeObject = type === "object";
    var isTypeFunction = type === "function";
    if ((isTypeObject || isTypeFunction) && value !== null) {
        var cached = _shareableCache.get(value);
        if (cached === _shareableFlag) {
            return value;
        } else if (cached !== undefined) {
            return cached;
        } else {
            var toAdapt;
            if (Array.isArray(value)) {
                toAdapt = value.map(function(element) {
                    return makeShareableCloneRecursive(element, shouldPersistRemote, depth + 1);
                });
            } else if (isTypeFunction && value.__workletHash === undefined) {
                toAdapt = value;
            } else if (isHostObject(value)) {
                toAdapt = value;
            } else if (isPlainJSObject(value) || isTypeFunction) {
                toAdapt = {};
                if (value.__workletHash !== undefined) {
                    if (__DEV__) {
                        var babelVersion = value.__initData.version;
                        if (babelVersion === undefined) {
                            throw new Error("[Reanimated] Unknown version of Reanimated Babel plugin.\nSee `https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#unknown-version-of-reanimated-babel-plugin` for more details. \nOffending code was: `".concat(getWorkletCode(value), "`"));
                        } else if (babelVersion !== _jsVersion.jsVersion) {
                            throw new Error("[Reanimated] Mismatch between JavaScript code version and Reanimated Babel plugin version (".concat(_jsVersion.jsVersion, " vs. ").concat(babelVersion, ").        \nSee `https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#mismatch-between-javascript-code-version-and-reanimated-babel-plugin-version` for more details.\nOffending code was: `").concat(getWorkletCode(value), "`"));
                        }
                        (0, _errors.registerWorkletStackDetails)(value.__workletHash, value.__stackDetails);
                        delete value.__stackDetails;
                    } else if (value.__stackDetails) {
                        throw new Error("[Reanimated] Using dev bundle in a release app build is not supported.\nSee `https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#using-dev-bundle-in-a-release-app-build-is-not-supported` for more details.");
                    }
                    toAdapt.__initData = makeShareableCloneRecursive(value.__initData, true, depth + 1);
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ref = _step.value;
                        var _ref2 = (0, _slicedToArray2.default)(_ref, 2);
                        var key = _ref2[0];
                        var element = _ref2[1];
                        toAdapt[key] = makeShareableCloneRecursive(element, shouldPersistRemote, depth + 1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else if (_instanceof(value, RegExp)) {
                var pattern = value.source;
                var flags = value.flags;
                var handle = makeShareableCloneRecursive({
                    __init: function() {
                        var _e = [
                            new global.Error(),
                            -3,
                            -27
                        ];
                        var anonymous = function anonymous() {
                            return new RegExp(pattern, flags);
                        };
                        anonymous.__closure = {
                            pattern: pattern,
                            flags: flags
                        };
                        anonymous.__initData = _worklet_17031627990684_init_data;
                        anonymous.__workletHash = 17031627990684;
                        anonymous.__stackDetails = _e;
                        return anonymous;
                    }()
                });
                registerShareableMapping(value, handle);
                return handle;
            } else {
                var inaccessibleObject = makeShareableCloneRecursive(INACCESSIBLE_OBJECT);
                _shareableCache.set(value, inaccessibleObject);
                return inaccessibleObject;
            }
            if (__DEV__) {
                Object.freeze(value);
            }
            var adopted = _NativeReanimated.default.makeShareableClone(toAdapt, shouldPersistRemote);
            _shareableCache.set(value, adopted);
            _shareableCache.set(adopted, _shareableFlag);
            return adopted;
        }
    }
    return _NativeReanimated.default.makeShareableClone(value, shouldPersistRemote);
}
var WORKLET_CODE_THRESHOLD = 255;
function getWorkletCode(value) {
    var _value$__initData;
    var code = value == null ? void 0 : (_value$__initData = value.__initData) == null ? void 0 : _value$__initData.code;
    if (!code) {
        return "unknown";
    }
    if (code.length > WORKLET_CODE_THRESHOLD) {
        return "".concat(code.substring(0, WORKLET_CODE_THRESHOLD), "...");
    }
    return code;
}
var _worklet_11770591563495_init_data = {
    code: "function isRemoteFunction(value){return!!value.__remoteFunction;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts",
    sourceMap: '{"version":3,"names":["isRemoteFunction","value","__remoteFunction"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts"],"mappings":"AA+PA,SAAAA,gBAASA,CAAiBC,KAAG,CAE5B,CAEC,MAAO,CAAC,CAACA,KAAK,CAACC,gBAAgB,CACjC"}',
    version: "3.5.4"
};
var isRemoteFunction = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isRemoteFunction = function isRemoteFunction(value) {
        return !!value.__remoteFunction;
    };
    isRemoteFunction.__closure = {};
    isRemoteFunction.__initData = _worklet_11770591563495_init_data;
    isRemoteFunction.__workletHash = 11770591563495;
    isRemoteFunction.__stackDetails = _e;
    return isRemoteFunction;
}();
var _worklet_6696410489807_init_data = {
    code: "function makeShareableCloneOnUIRecursive(value){const{USE_STUB_IMPLEMENTATION,isHostObject,isRemoteFunction}=this.__closure;if(USE_STUB_IMPLEMENTATION){return value;}function cloneRecursive(value){if(typeof value==='object'&&value!==null||typeof value==='function'){if(isHostObject(value)){return _makeShareableClone(value);}if(isRemoteFunction(value)){return value.__remoteFunction;}if(Array.isArray(value)){return _makeShareableClone(value.map(cloneRecursive));}const toAdapt={};for(const[key,element]of Object.entries(value)){toAdapt[key]=cloneRecursive(element);}return _makeShareableClone(toAdapt);}return _makeShareableClone(value);}return cloneRecursive(value);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts",
    sourceMap: '{"version":3,"names":["makeShareableCloneOnUIRecursive","value","USE_STUB_IMPLEMENTATION","isHostObject","isRemoteFunction","__closure","cloneRecursive","_makeShareableClone","__remoteFunction","Array","isArray","map","toAdapt","key","element","Object","entries"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts"],"mappings":"AAsQO,SAAAA,+BAASA,CAAgCC,KAC9C,CACD,OAAAC,uBAAA,CAAAC,YAAA,CAAAC,gBAAA,OAAAC,SAAA,CAEC,GAAIH,uBAAuB,CAAE,CAG3B,MAAO,CAAAD,KAAK,CACd,CACA,QAAS,CAAAK,cAAcA,CAAIL,KAAQ,CAAuB,CACxD,GACG,MAAO,CAAAA,KAAK,GAAK,QAAQ,EAAIA,KAAK,GAAK,IAAI,EAC5C,MAAO,CAAAA,KAAK,GAAK,UAAU,CAC3B,CACA,GAAIE,YAAY,CAACF,KAAK,CAAC,CAAE,CAGvB,MAAO,CAAAM,mBAAmB,CAACN,KAAK,CAAC,CACnC,CACA,GAAIG,gBAAgB,CAAIH,KAAK,CAAC,CAAE,CAI9B,MAAO,CAAAA,KAAK,CAACO,gBAAgB,CAC/B,CACA,GAAIC,KAAK,CAACC,OAAO,CAACT,KAAK,CAAC,CAAE,CACxB,MAAO,CAAAM,mBAAmB,CACxBN,KAAK,CAACU,GAAG,CAACL,cAAc,CAC1B,CAAC,CACH,CACA,KAAM,CAAAM,OAA4C,CAAG,CAAC,CAAC,CACvD,IAAK,KAAM,CAACC,GAAG,CAAEC,OAAO,CAAC,EAAI,CAAAC,MAAM,CAACC,OAAO,CAACf,KAAK,CAAC,CAAE,CAClDW,OAAO,CAACC,GAAG,CAAC,CAAGP,cAAc,CAAIQ,OAAO,CAAC,CAC3C,CACA,MAAO,CAAAP,mBAAmB,CAACK,OAAO,CAAC,CACrC,CACA,MAAO,CAAAL,mBAAmB,CAACN,KAAK,CAAC,CACnC,CACA,MAAO,CAAAK,cAAc,CAACL,KAAK,CAAC,CAC9B"}',
    version: "3.5.4"
};
var makeShareableCloneOnUIRecursive = exports.makeShareableCloneOnUIRecursive = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var makeShareableCloneOnUIRecursive = function makeShareableCloneOnUIRecursive(value) {
        if (USE_STUB_IMPLEMENTATION) {
            return value;
        }
        function cloneRecursive(value) {
            if (typeof value === "object" && value !== null || typeof value === "function") {
                if (isHostObject(value)) {
                    return _makeShareableClone(value);
                }
                if (isRemoteFunction(value)) {
                    return value.__remoteFunction;
                }
                if (Array.isArray(value)) {
                    return _makeShareableClone(value.map(cloneRecursive));
                }
                var toAdapt = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ref3 = _step.value;
                        var _ref4 = (0, _slicedToArray2.default)(_ref3, 2);
                        var key = _ref4[0];
                        var element = _ref4[1];
                        toAdapt[key] = cloneRecursive(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _makeShareableClone(toAdapt);
            }
            return _makeShareableClone(value);
        }
        return cloneRecursive(value);
    };
    makeShareableCloneOnUIRecursive.__closure = {
        USE_STUB_IMPLEMENTATION: USE_STUB_IMPLEMENTATION,
        isHostObject: isHostObject,
        isRemoteFunction: isRemoteFunction
    };
    makeShareableCloneOnUIRecursive.__initData = _worklet_6696410489807_init_data;
    makeShareableCloneOnUIRecursive.__workletHash = 6696410489807;
    makeShareableCloneOnUIRecursive.__stackDetails = _e;
    return makeShareableCloneOnUIRecursive;
}();
var _worklet_15913789835932_init_data = {
    code: "function anonymous(){const{value}=this.__closure;return value;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts",
    sourceMap: '{"version":3,"names":["anonymous","value","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/shareables.ts"],"mappings":"AAoTY,SAAAA,SAAMA,CAAA,QAAAC,KAAA,OAAAC,SAAA,CAEZ,MAAO,CAAAD,KAAK,CACd"}',
    version: "3.5.4"
};
function makeShareable(value) {
    if (USE_STUB_IMPLEMENTATION) {
        return value;
    }
    var handle = makeShareableCloneRecursive({
        __init: function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous() {
                return value;
            };
            anonymous.__closure = {
                value: value
            };
            anonymous.__initData = _worklet_15913789835932_init_data;
            anonymous.__workletHash = 15913789835932;
            anonymous.__stackDetails = _e;
            return anonymous;
        }()
    });
    registerShareableMapping(value, handle);
    return value;
}
